import type { LauraStageId } from "@/app/components/shared/types";
import { LAURA_STAGES } from "./stages";

export function getNextStageId(id: LauraStageId): LauraStageId | null {
    const idx = LAURA_STAGES.findIndex((s) => s.id === id);
    if (idx < 0 || idx >= LAURA_STAGES.length - 1) return null;
    return LAURA_STAGES[idx + 1].id;
}
